module.exports = __webpack_public_path__ + "img/5.a2536a58.jpg";